module.exports = __webpack_public_path__ + "img/2021_10_dande_TVasa_0907-2_fin_web.b00031cf.png";